import { Component }  from '@angular/core';
import * as moment_ from 'moment';
import { GridLength } from 'source/app/objects/request/grid-length';
import { ColumnType } from 'source/app/objects/request/column-type';
import { Column } from 'source/app/objects/request/column';
import { Dictionary } from 'source/app/objects/dictionary';


const moment: any = (<any>moment_).default || moment_;

@Component({
  templateUrl: './grid.html'  
})
export class GridComponent { 

    constructor() { }

    ngOnInit() {

      var columns = new Dictionary<Column>();
      for (var i=0; i<26; i++) {
        var name = String.fromCharCode(i + 65);
        if (i%5==0) {
          //return new Column("_filler", "", "", ColumnType.Fill, new GridLength(0), undefined, undefined, undefined, undefined, undefined, undefined, undefined, true, true, undefined, undefined);   
          columns.add(name, new Column(name, name, i.toString(), ColumnType.String, new GridLength(100), "center", "center"));
        } else if (i%5==1) {
          columns.add(name, new Column(name, name, i.toString(), ColumnType.Number, new GridLength(100), "center", "center"));
        } else if (i%5==2) {
          columns.add(name, new Column(name, name, i.toString(), ColumnType.Number, new GridLength(100), "center", "center"));
        } else if (i%5==3) {
          columns.add(name, new Column(name, name, i.toString(), ColumnType.String, new GridLength(200), "center", "center"));
        } else {
          columns.add(name, new Column(name, name, i.toString(), ColumnType.Date, new GridLength(100), "center", "center"));
        }
      }
    
    
      var rows = [];
      for (var i=0; i<100; i++) {
        var row = {};
    
        for (var j=0; j<26; j++) {
          if (j%5==0){
            row[j] = String.fromCharCode(j + 65) + "." + (i + 1);
          } else if (j%5==1) {
            row[j] = i+1;
          } else if (j%5==2) {
            row[j] = Math.floor((Math.random() * 5) + 1);;
          } else if (j%5==3) {
            row[j] = i+': This is text that should be too wide for the filter dialog.';
          } else {
            row[j] = moment(moment('01-JAN-2018', 'DD-MMM-YYYY').toDate()).add(i, 'd').startOf('day').toDate();
          }
        }
        
        rows.push(row);
      }
    
      this.Columns = columns;
      this.ItemsSource = rows;
    }

    Columns: Dictionary<Column> = new Dictionary<Column>();
    ItemsSource: Array<any> = new Array<any>();
    public SelectedItem;

    public Properties() {
        return "Hellog ";
    }
}


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/test/views/home/grid/grid-component.ts